export const isUnchanged = (current, next) =>
  typeof current === 'object' || typeof next === 'object'
    ? JSON.stringify(current) === JSON.stringify(next)
    : current === next

const nonKeyProperties = new Set(['type', 'actionType', 'data', 'value'])

/**
 * Handle simple state updates in a reducer. Use for single property setters.
 * @param {*} state provider state
 * @param {*} action reducer action: { type: string, key?: string, data?: any, [propToSet]: any }
 * @returns state w/ updated property
 */
export default function handleReducerSimpleSetter(state, action) {
  const keys = action?.key ? [action?.key] : Object.keys(action).filter((k) => !nonKeyProperties.has(k)) // find one key for the variable to set if a simple setter
  if (keys?.length !== 1) {
    throw new Error('ERROR: handleReducerSimpleSetter expects exactly one property to set on the action object')
  }
  const keyToSet = keys[0]
  const data = action?.data ?? action[keyToSet]
  if (keyToSet && isUnchanged(state[keyToSet], data)) return state
  return { ...state, [keyToSet]: data }
}
